import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { completeOidcCallback } from './oidcAuth';
import { getMessages } from '../i18n';
/**
 * Drop-in element for the `/auth/callback` route (OIDC_CALLBACK_PATH) —
 * mounted OUTSIDE the auth gate so the exchange can run unauthenticated.
 * On success it hard-navigates to the sanitized pre-login path (full remount
 * → the auth hook reads the fresh user from the session store).
 */
export function OidcCallbackScreen({ config, locale }) {
    const [failed, setFailed] = useState(false);
    // Per-render, same reason as AuthGate: this is the callback-failure copy a fixed-RU admin
    // panel renders under `<html lang="ru">`, and a module-scope resolve made it English.
    const t = getMessages(locale);
    useEffect(() => {
        let cancelled = false;
        completeOidcCallback(config)
            .then((returnTo) => {
            if (!cancelled)
                window.location.replace(returnTo);
        })
            .catch(() => {
            if (!cancelled)
                setFailed(true);
        });
        return () => {
            cancelled = true;
        };
        // config is stable per shell build; the exchange must run exactly once
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    if (failed) {
        return (_jsxs("div", { className: "flex h-full flex-col items-center justify-center gap-3 p-6 text-center", children: [_jsx("p", { className: "text-muted", children: t.auth.callbackFailed }), _jsx("a", { href: "/", className: "text-sm font-medium text-accent hover:text-accent-deep", children: t.auth.backHome })] }));
    }
    return (_jsx("div", { className: "flex h-full items-center justify-center p-6 text-center", children: _jsx("p", { className: "text-muted", children: t.auth.loading }) }));
}
//# sourceMappingURL=OidcCallbackScreen.js.map